import { Button, Col, Grid, Row, Skeleton, Typography } from "antd"
import { ContactModal } from "../ContactModal/web"
import { FinancingInput } from "../FinancingInput/FinancingInput"
import { formatMoney, isCommerce } from "../../../Utils/Functions"
import { ImagenOptimizada } from "../../Image/web"
import { Input } from "../dataInputs"
import { useMapfreFinancing } from "./hook"
import { useState } from "react"
import { useTheme } from "../../../Styles/ThemeHook"
import "./styles.less"

const { useBreakpoint } = Grid;

const DESKTOP_SOURCE = 0;
const MOBILE_SOURCE = 4;

const LEAD_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/mapfre/sendForm";

export const MapfreFinancing = ({
	id,
	propertyType,
	isDisabledProperty = false,
	showFinancingCard = false,
	financingRef = null,
}) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const screen = useBreakpoint();
	const source = screen.lg ? DESKTOP_SOURCE : MOBILE_SOURCE;
	const { theme } = useTheme();
	const [modal, setModal] = useState(false);
	const {
		priceAmount: { value: priceAmount, change: setPriceAmount },
		currency,
		minimumIncome,
		annualFees,
		cash,
		loading,
		extraData,
	} = useMapfreFinancing({ property_id: id, source });

	const onScrollToFinancing = () => {
		if (financingRef) {
			const componentFinancing = financingRef.current.offsetTop;
			const withAffixHeight = screen.lg ? 30 : 0;
			const scrollingTo = componentFinancing - withAffixHeight;
			window.scrollTo({ top: scrollingTo, behavior: "smooth" });
		}
	};

	const handleInputChange = (value, type) => {
		if (type === "plus") setPriceAmount(value + 1);
		else if (type === "minus") setPriceAmount(value - 1);
		else setPriceAmount(value)
	}

	if (showFinancingCard) {
		return (
			<div className="property-financing-mapfre-card">
				<div className="mapfre-container">
					<ImagenOptimizada
						src="https://cdn2.infocasas.com.uy/web/5eecaacba7a8d_infocdn__mapfre-blancosinfondo.png"
						alt="MAPFRE"
					/>
					<Button onClick={onScrollToFinancing} className="mapfre-btn">
						Calcular Garantía
					</Button>
				</div>
			</div>
		);
	}

	return (
		<div className="property-financing-mapfre">
			<Row align={"middle"} gutter={[0, { xs: theme.spacing.lgSpacing }]}>
				<Col xs={24} md={12}>
					<div className="property-financing-box">
						<div className="mapfre-logo">
							<ImagenOptimizada
								src="https://cdn2.infocasas.com.uy/web/5eecaacba7a8d_infocdn__mapfre-blancosinfondo.png"
								alt="MAPFRE"
							/>
						</div>
						<Row gutter={[theme.spacing.xxlSpacing, theme.spacing.mdSpacing]}>
							<Col xs={24}>
								<FinancingInput
									title="Importe de Alquiler"
									input={
										<Input
											isDisabledProperty={isDisabledProperty}
											value={priceAmount}
											onChange={(value, type) => handleInputChange(value, type)}
											currency={currency}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24}>
								<FinancingInput
									title="Ingresos necesarios para este alquiler."
									input={
										loading ? (
											<Skeleton.Button size="small" active />
										) : (
											<Typography.Paragraph>
												{currency} {formatMoney(minimumIncome)}
											</Typography.Paragraph>
										)
									}
									bottom={
										<Typography.Paragraph className="financing-small-text">
											{isCommerce(propertyType)
												? "Para alquileres comerciales, el alquiler máximo asegurable no podrá ser mayor al 30% sobre utilidades"
												: "El ingreso liquido requerido puede ser compuesto por los ingresos de hasta 3 personas."}
										</Typography.Paragraph>
									}
									fullWidth
								/>
							</Col>
						</Row>
					</div>
				</Col>
				<Col xs={24} md={12} className="property-financing-results">
					<Typography.Title level={2}>Garantía</Typography.Title>
					<Row>
						<Col xs={isCommerce(propertyType) ? 24 : 12}>
							<Typography className="financing-subprice">
								{isCommerce(propertyType)
									? "Costo anual de la Garantía"
									: "Contado"}
							</Typography>
							{loading ? (
								<Skeleton.Button size="small" active />
							) : (
								<Typography className="financing-price">
									{currency} {formatMoney(cash)}
								</Typography>
							)}
						</Col>
						{isCommerce(propertyType) ? null : (
							<Col xs={12}>
								<Typography className="financing-subprice">
									{isCommerce(propertyType)
										? "Costo anual de la Garantía"
										: "¡12 cuotas sin recargo!"}
								</Typography>
								{loading ? (
									<Skeleton.Button size="small" active />
								) : (
									<Typography className="financing-price">
										{currency} {formatMoney(annualFees)}
									</Typography>
								)}
							</Col>
						)}
					</Row>
					<Typography className="financing-subprice bottom">
						{isCommerce(propertyType)
							? "Consulte por opciones de financiación"
							: "Consulta por las promociones vigentes con tarjeta de crédito"}
					</Typography>
					<Button
						disabled={isDisabledProperty}
						className="mapfre-financing-button"
						onClick={() => setModal(true)}>
						Solicitar más información
					</Button>
				</Col>
			</Row>
			<ContactModal
				sendLeadURL={LEAD_SERVICE}
				extraData={{ ...extraData, extra: "Mapfre - Desde ficha propiedad" }}
				source={source}
				onSuccess={() => {
					setModal(false);
					handleClickShowNotification({
						message: "¡Gracias por tu consulta!",
						description: "Tus datos han sido enviados con éxito. En las próximas horas nos contactaremos contigo para darte más información.",
					});
				}}
				showCI
				title="¡Solicitar mi Garantía!"
				topText="Completá los datos que faltan y uno de nuestros agentes se contactará contigo"
				bottomText={
					isCommerce(propertyType)
						? [
							"Para alquileres comerciales, el alquiler máximo asegurable no podrá ser mayor al 30% sobre utilidades",
							"El tiempo máximo de análisis será de 48 hs.",
						]
						: [
							"El importe máximo a garantizar será de hasta el 30% del ingreso líquido del solicitante.",
							"Se podrá hacer composición de ingresos de hasta tres personas en total, las cuales serán co-titulares del contrato de arrendamiento y de la póliza de seguro.",
							"El tiempo máximo de análisis será de 48 hs.",
							"El costo detallado es independiente de la cantidad de solicitantes que se incorporen al estudio.",
						]
				}
				visible={modal}
				closeModal={() => setModal(false)}
			/>
		</div>
	);
};
